import { Provider } from '@angular/core';
import { TICKET_NOTARY_REPOSITORY } from './application/ticket-notary.tokens';
import { HttpTicketNotaryRepository } from './infrastructure/http/http-ticket-notary.repository';
import { GetTicketNotaryDetailUseCase } from './application/get-ticket-notary-detail.usecase';
import { RegisterTicketNotaryUseCase } from './application/register-ticket-notary.usecase';
import { UpdateTicketNotaryFieldUseCase } from './application/update-ticket-notary-field.usecase';

export const TICKET_NOTARY_PROVIDERS: Provider[] = [
  { provide: TICKET_NOTARY_REPOSITORY, useClass: HttpTicketNotaryRepository },
  GetTicketNotaryDetailUseCase,
  RegisterTicketNotaryUseCase,
  UpdateTicketNotaryFieldUseCase,
];
